import { AccessContext } from "./accessContext";

/** A branch row's id as the branch switcher keys it (a user-location map row carries it under location). */
export const locationKey = (row: any): string => (row?.location?.id ? row.location.id : row?.id) ?? "";

/** The branch picked on this device, when it is one of this company's; only support sessions keep one. */
export const storedLocation = (locations: unknown): any => {
  const stored = localStorage.getItem("locationId");
  if (!stored || !Array.isArray(locations)) return undefined;
  return locations.find((row) => locationKey(row) === stored);
};

// Support cannot move the customer's company-wide branch, so its pick lives in localStorage.
export const selectedLocation = (locations: unknown, ctx: AccessContext): any => {
  const rows = Array.isArray(locations) ? locations : [];
  return (ctx.mode === "support" && storedLocation(rows)) || rows.find((row) => row?.isCurrentActive);
};
